import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Boston Legal is a huge time hog",
  "description": "",
  "published": "2008-09-30T00:00:00.000Z",
  "redirect_from": ["/blog/boston-legal-is-a-huge-time-hog/swizec/64"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Lately I've been watching a lot of Boston Legal and I'm not quite certain how I got into it, think I saw it on telly once or twice then suddenly decided to simply download the remainder when I noticed our television wasn't airing it anymore. So off I went and downloaded season three and four then started watching and watching and watching and watching similarly to how Alan Shore just goes on and on and on.`}</p>
    <p>{`Boston Legal is a pretty sweet show even though it's difficult to say just what exactly it is that draws me to it. It's actually quite the opposite of high quality, it's far from perfect, has many continuity problems and more often than not is rather difficult to follow and at times their humor is just unfunny.`}</p>
    <p>{`But nevertheless, once you start watching it's difficult to stop so there were nights when I spent six hours in a row just watching Boston Legal, not that I could now tell you the story or even what happened. The show is much like Jane Austen's Pride and Prejudice in that regard, yes you have much fun reading/watching it, yes you love it and yes you even connect with the characters, but as soon as someone asks what the story is you can't go farther than: `}<em parentName="p">{`Well it's about lawyers and they have cases and stuff`}</em></p>
    <p>{`There is but one qualm I have with Boston Legal, it seems to suffer a lot from vanishing characters. There is for example the case of that blonde lawyer girl who was with the main cast for several seasons then suddenly up and vanished one episode to another, first she got pregnant, then in the next episode she was several months pregnant (wtf here already) and in the next episode she was omited from the intro and everything. Same goes for her fresh hubby, they married, he vanished from the show. Or for that cross-dresser loving broad who simply vanished as well, no explanations given. This is otherwise known as the `}<em parentName="p">{`Chuck Cunningham Syndrome`}</em></p>
    <p>{`All in all, I love the show and fully intend on watching it one episode at a time now that I'm being concurrent with fifth season.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      